/* eslint-disable react/function-component-definition */
import { ButtonProps } from '@mui/material';
import React from 'react';
import { StyledButton } from './styles';

interface Props extends ButtonProps {
  children: React.ReactNode;
  variant: 'text' | 'contained' | 'outlined';
  size?: 'small' | 'medium' | 'large';
  width?: string;
}

export const BasicButton: React.FC<Props> = ({ children, onClick, variant, size, ...props }) => {
  return (
    <StyledButton onClick={onClick} variant={variant} size={size} {...props}>
      {children}
    </StyledButton>
  );
};
